module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-vi-VN.b5f392bc.jpg";